export function unixtimeToISO8601(unixtime: number, _offset?: number) : string {
    // Return string containing timestamp in the "YYYYMMDDTHHMMSSz" format
    // eventtime is a UTC unix timestamp; Z suffix in ICS means UTC — no offset adjustment needed
    // 20090621T063000Z = 21. June 2009 06:30:00 UTC

    const d = new Date(unixtime * 1000);

    const year    = d.getUTCFullYear();
    const month   = d.getUTCMonth()+1; // compensating for the fact that this func returns months in the interval 0..11
    const date    = d.getUTCDate();
    const hour    = d.getUTCHours();
    const minute  = d.getUTCMinutes();
    const second  = d.getUTCSeconds();

    const timeStr = year +
                  String(month < 10 ? ('0' + month) : month) +
                  String(date < 10 ? ('0' + date) : date) +
                  'T' +
                  String(hour < 10 ? ('0' + hour) : hour) +
                  String(minute < 10 ? ('0' + minute) : minute) +
                  String(second < 10 ? ('0' + second) : second) +
                  'Z';

    return timeStr;
  };